import { motion, useAnimation } from 'framer-motion';
import React, { useEffect, useLayoutEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import './aboutUs.css';

function AboutUs() {
    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    const animation = useAnimation();
    const [featuredRef, inView] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView) {
            animation.start("visible")
        }
    }, [animation, inView])

    const animation2 = useAnimation();
    const [featuredRef2, inView2] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView2) {
            animation2.start("visible")
        }
    }, [animation2, inView2])

    const animation3 = useAnimation();
    const [featuredRef3, inView3] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView3) {
            animation3.start("visible")
        }
    }, [animation3, inView3])
    const animation4 = useAnimation();
    const [featuredRef4, inView4] = useInView({
        triggerOnce: true,
        rootMargin: '10px'
    });
    useEffect(() => {
        if(inView4) {
            animation4.start("visible")
        }
    }, [animation4, inView4])
    const animation5 = useAnimation();
    const [featuredRef5, inView5] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView5) {
            animation5.start("visible")
        }
    }, [animation5, inView5])
    const animation6 = useAnimation();
    const [featuredRef6, inView6] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView6) {
            animation6.start("visible")
        }
    }, [animation6, inView6])
    const animation7 = useAnimation();
    const [featuredRef7, inView7] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView7) {
            animation7.start("visible")
        }
    }, [animation7, inView7])
    const animation8 = useAnimation();
    const [featuredRef8, inView8] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView8) {
            animation8.start("visible")
        }
    }, [animation8, inView8])
    const animation9 = useAnimation();
    const [featuredRef9, inView9] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView9) {
            animation9.start("visible")
        }
    }, [animation9, inView9])
    const animation10 = useAnimation();
    const [featuredRef10, inView10] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView10) {
            animation10.start("visible")
        }
    }, [animation10, inView10])
    const animation11 = useAnimation();
    const [featuredRef11, inView11] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView11) {
            animation11.start("visible")
        }
    }, [animation11, inView11])
    const animation12 = useAnimation();
    const [featuredRef12, inView12] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView12) {
            animation12.start("visible")
        }
    }, [animation12, inView12])
    const animation13 = useAnimation();
    const [featuredRef13, inView13] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView13) {
            animation13.start("visible")
        }
    }, [animation13, inView13])
    const animation14 = useAnimation();
    const [featuredRef14, inView14] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView14) {
            animation14.start("visible")
        }
    }, [animation14, inView14])
    const animation15 = useAnimation();
    const [featuredRef15, inView15] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView15) {
            animation15.start("visible")
        }
    }, [animation15, inView15])
    const animation16 = useAnimation();
    const [featuredRef16, inView16] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView16) {
            animation16.start("visible")
        }
    }, [animation16, inView16])
    const animation17 = useAnimation();
    const [featuredRef17, inView17] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView17) {
            animation17.start("visible")
        }
    }, [animation17, inView17])
    const animation18 = useAnimation();
    const [featuredRef18, inView18] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView18) {
            animation18.start("visible")
        }
    }, [animation18, inView18])
    const animation19 = useAnimation();
    const [featuredRef19, inView19] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView19) {
            animation19.start("visible")
        }
    }, [animation19, inView19])
    const animation20 = useAnimation();
    const [featuredRef20, inView20] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView20) {
            animation20.start("visible")
        }
    }, [animation20, inView20])
    const animation21 = useAnimation();
    const [featuredRef21, inView21] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView21) {
            animation21.start("visible")
        }
    }, [animation21, inView21])
    const animation22 = useAnimation();
    const [featuredRef22, inView22] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView22) {
            animation22.start("visible")
        }
    }, [animation22, inView22])
    const animation23 = useAnimation();
    const [featuredRef23, inView23] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView23) {
            animation23.start("visible")
        }
    }, [animation23, inView23])
    const animation24 = useAnimation();
    const [featuredRef24, inView24] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView24) {
            animation24.start("visible")
        }
    }, [animation24, inView24])
    const animation25 = useAnimation();
    const [featuredRef25, inView25] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView25) {
            animation25.start("visible")
        }
    }, [animation25, inView25])
    const animation26 = useAnimation();
    const [featuredRef26, inView26] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView26) {
            animation26.start("visible")
        }
    }, [animation26, inView26])
    const animation27 = useAnimation();
    const [featuredRef27, inView27] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView27) {
            animation27.start("visible")
        }
    }, [animation27, inView27])
    const animation28 = useAnimation();
    const [featuredRef28, inView28] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView28) {
            animation28.start("visible")
        }
    }, [animation28, inView28])
    const animation29 = useAnimation();
    const [featuredRef29, inView29] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView29) {
            animation29.start("visible")
        }
    }, [animation29, inView29])
    const animation30 = useAnimation();
    const [featuredRef30, inView30] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView30) {
            animation30.start("visible")
        }
    }, [animation30, inView30])
    const animation31 = useAnimation();
    const [featuredRef31, inView31] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView31) {
            animation31.start("visible")
        }
    }, [animation31, inView31])
    const animation32 = useAnimation();
    const [featuredRef32, inView32] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView32) {
            animation32.start("visible")
        }
    }, [animation32, inView32])
    const animation33 = useAnimation();
    const [featuredRef33, inView33] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView33) {
            animation33.start("visible")
        }
    }, [animation33, inView33])
    const animation34 = useAnimation();
    const [featuredRef34, inView34] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView34) {
            animation34.start("visible")
        }
    }, [animation34, inView34])
    const animation35 = useAnimation();
    const [featuredRef35, inView35] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView35) {
            animation35.start("visible")
        }
    }, [animation35, inView35])
    const animation36 = useAnimation();
    const [featuredRef36, inView36] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView36) {
            animation36.start("visible")
        }
    }, [animation36, inView36])
    const animation37 = useAnimation();
    const [featuredRef37, inView37] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView37) {
            animation37.start("visible")
        }
    }, [animation37, inView37])
    const animation38 = useAnimation();
    const [featuredRef38, inView38] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView38) {
            animation38.start("visible")
        }
    }, [animation38, inView38])
    const animation39 = useAnimation();
    const [featuredRef39, inView39] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView39) {
            animation39.start("visible")
        }
    }, [animation39, inView39])
    const animation40 = useAnimation();
    const [featuredRef40, inView40] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView40) {
            animation40.start("visible")
        }
    }, [animation40, inView40])
    const animation41 = useAnimation();
    const [featuredRef41, inView41] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView41) {
            animation41.start("visible")
        }
    }, [animation41, inView41])
    const animation42 = useAnimation();
    const [featuredRef42, inView42] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView42) {
            animation34.start("visible")
        }
    }, [animation42, inView42])

    // ref={featuredRef} animate={animation} initial = 'hidden' variants = {{visible: {y: 400, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.2, staggerChildren: 0.1}}, hidden: {y: 400, opacity: 0}}}
    return (
        <div className="aboutUs">
            <div className="aboutUs__div1">
                <div className="aboutUs__div2">
                    <h3 className="about1">About Us</h3>
                </div>
                <div className="aboutUs__div3">
                    <div className="about__div4">
                        <motion.h1 className="about__line1">
                            <motion.h1 ref={featuredRef} animate={animation} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1}, }, hidden: {y: 70, opacity: 0}}} className="about__span1">We</motion.h1> 
                            <motion.h1 ref={featuredRef2} animate={animation2} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.1}}, hidden: {y: 70, opacity: 0}}} className="about__span1"> help</motion.h1> 
                            <motion.h1 ref={featuredRef2} animate={animation2} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.2}}, hidden: {y: 70, opacity: 0}}} className="about__span1"> businesses</motion.h1> 
                            <motion.h1 ref={featuredRef2} animate={animation2} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.3}}, hidden: {y: 70, opacity: 0}}} className="about__span1"> to</motion.h1>
                        </motion.h1>
                    </div>
                    <div className="about__div5">
                        <h1 className="about__line1">
                            <motion.h1 ref={featuredRef3} animate={animation3} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.4}}, hidden: {y: 70, opacity: 0}}} className="about__span1">re-evaluate</motion.h1>
                            <motion.h1 ref={featuredRef4} animate={animation4} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.5}}, hidden: {y: 70, opacity: 0}}} className="about__span1">their</motion.h1>
                            <motion.h1 ref={featuredRef4} animate={animation4} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.6}}, hidden: {y: 70, opacity: 0}}} className="about__span1">digital</motion.h1>
                        </h1>
                    </div>
                    <div className="about__div6">
                        <h1 className="about__line1">
                        <motion.h1 ref={featuredRef5} animate={animation5} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.7}}, hidden: {y: 70, opacity: 0}}} className="about__span1">potential</motion.h1>
                        <motion.h1 ref={featuredRef6} animate={animation6} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.8}}, hidden: {y: 70, opacity: 0}}} className="about__span1">and</motion.h1>
                        <motion.h1 ref={featuredRef6} animate={animation6} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.9}}, hidden: {y: 70, opacity: 0}}} className="about__span1">achieve</motion.h1>
                        <motion.h1 ref={featuredRef6} animate={animation6} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1}}, hidden: {y: 70, opacity: 0}}} className="about__span1">greater</motion.h1>
                        </h1>
                    </div>
                    <div className="about__div7">
                        <h1 className="about__line1">
                        <motion.h1 ref={featuredRef7} animate={animation7} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.1}}, hidden: {y: 70, opacity: 0}}} className="about__span1">results.</motion.h1>
                        <motion.h1 ref={featuredRef8} animate={animation8} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.2}}, hidden: {y: 70, opacity: 0}}} className="about__span1">Corporate</motion.h1>
                        <motion.h1 ref={featuredRef8} animate={animation8} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.3}}, hidden: {y: 70, opacity: 0}}} className="about__span1">level</motion.h1>
                        </h1>
                    </div>
                    <div className="about__div8">
                        <h1 className="about__line1">
                        <motion.h1 ref={featuredRef9} animate={animation9} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.4}}, hidden: {y: 70, opacity: 0}}} className="about__span1">companies</motion.h1>
                        <motion.h1 ref={featuredRef10} animate={animation10} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.5}}, hidden: {y: 70, opacity: 0}}} className="about__span1">trust</motion.h1>
                        <motion.h1 ref={featuredRef10} animate={animation10} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.6}}, hidden: {y: 70, opacity: 0}}} className="about__span1">us</motion.h1>
                        <motion.h1 ref={featuredRef10} animate={animation10} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.7}}, hidden: {y: 70, opacity: 0}}} className="about__span1">to</motion.h1>
                        <motion.h1 ref={featuredRef10} animate={animation10} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.8}}, hidden: {y: 70, opacity: 0}}} className="about__span1">refresh</motion.h1>
                        </h1>
                    </div>
                    <div className="about__div9">
                        <h1 className="about__line1">
                        <motion.h1 ref={featuredRef11} animate={animation11} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.9}}, hidden: {y: 70, opacity: 0}}} className="about__span1">and</motion.h1>
                        <motion.h1 ref={featuredRef12} animate={animation12} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2}}, hidden: {y: 70, opacity: 0}}} className="about__span1">improve</motion.h1>
                        <motion.h1 ref={featuredRef12} animate={animation12} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.1}}, hidden: {y: 70, opacity: 0}}} className="about__span1">their</motion.h1>
                        <motion.h1 ref={featuredRef12} animate={animation12} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.2}}, hidden: {y: 70, opacity: 0}}} className="about__span1">brands</motion.h1>
                        </h1>
                    </div>
                    <div className="about__div10">
                        <h1 className="about__line1">
                        <motion.h1 ref={featuredRef13} animate={animation13} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.3}}, hidden: {y: 70, opacity: 0}}} className="about__span1">online.</motion.h1>
                        <motion.h1 ref={featuredRef14} animate={animation14} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.4}}, hidden: {y: 70, opacity: 0}}} className="about__span1">Start-ups</motion.h1>
                        <motion.h1 ref={featuredRef14} animate={animation14} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.5}}, hidden: {y: 70, opacity: 0}}} className="about__span1">- to</motion.h1>
                        <motion.h1 ref={featuredRef14} animate={animation14} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.6}}, hidden: {y: 70, opacity: 0}}} className="about__span1">launch</motion.h1>
                        </h1>
                    </div>
                    <div className="about__div11">
                        <h1 className="about__line1">
                        <motion.h1 ref={featuredRef15} animate={animation15} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.7}}, hidden: {y: 70, opacity: 0}}} className="about__span1">and</motion.h1>
                        <motion.h1 ref={featuredRef16} animate={animation16} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.8}}, hidden: {y: 70, opacity: 0}}} className="about__span1">set</motion.h1>
                        <motion.h1 ref={featuredRef16} animate={animation16} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.9}}, hidden: {y: 70, opacity: 0}}} className="about__span1">a</motion.h1>
                        <motion.h1 ref={featuredRef16} animate={animation16} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 3}}, hidden: {y: 70, opacity: 0}}} className="about__span1">visual</motion.h1>
                        <motion.h1 ref={featuredRef16} animate={animation16} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 3.1}}, hidden: {y: 70, opacity: 0}}} className="about__span1">tone.</motion.h1>
                        </h1>
                    </div>
                </div>
            </div>
            <div className="homeProduct__div20"></div>
            <div className="about__div12">
                <div className="about__div13">
                    <h3 className="homeProduct__line5">What we do</h3>
                </div>
            </div>
            <div className="about__div15">
                <div className="about__div16">
                    <div className="about__div17">
                        <h3 className="about1">Services</h3>
                    </div>
                    <div className="about__div18">
                        <div className="about__div19">
                            <h1 className="about__line2">
                            <motion.h1 ref={featuredRef17} animate={animation17} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.8}}, hidden: {y: 70, opacity: 0}}} className="about__span1">We</motion.h1>
                            <motion.h1 ref={featuredRef18} animate={animation18} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.9}}, hidden: {y: 70, opacity: 0}}} className="about__span1">know</motion.h1>
                            <motion.h1 ref={featuredRef18} animate={animation18} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1}}, hidden: {y: 70, opacity: 0}}} className="about__span1">it</motion.h1>
                            <motion.h1 ref={featuredRef18} animate={animation18} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.1}}, hidden: {y: 70, opacity: 0}}} className="about__span1">is</motion.h1>
                            <motion.h1 ref={featuredRef18} animate={animation18} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.2}}, hidden: {y: 70, opacity: 0}}} className="about__span1">quite</motion.h1>
                            </h1>
                        </div>
                        <div className="about__div20">
                            <h1 className="about__line2">
                            <motion.h1 ref={featuredRef19} animate={animation19} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.3}}, hidden: {y: 70, opacity: 0}}} className="about__span1">challenging</motion.h1>
                            <motion.h1 ref={featuredRef20} animate={animation20} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.4}}, hidden: {y: 70, opacity: 0}}} className="about__span1">to</motion.h1>
                            <motion.h1 ref={featuredRef20} animate={animation20} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.5}}, hidden: {y: 70, opacity: 0}}} className="about__span1">find</motion.h1>
                            <motion.h1 ref={featuredRef20} animate={animation20} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.6}}, hidden: {y: 70, opacity: 0}}} className="about__span1">a</motion.h1>
                            <motion.h1 ref={featuredRef20} animate={animation20} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.7}}, hidden: {y: 70, opacity: 0}}} className="about__span1">good</motion.h1>
                            </h1>
                        </div>
                        <div className="about__div20">
                            <h1 className="about__line2">
                            <motion.h1 ref={featuredRef21} animate={animation21} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.8}}, hidden: {y: 70, opacity: 0}}} className="about__span1">team</motion.h1>
                            <motion.h1 ref={featuredRef22} animate={animation22} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.9}}, hidden: {y: 70, opacity: 0}}} className="about__span1">to</motion.h1>
                            <motion.h1 ref={featuredRef22} animate={animation22} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2}}, hidden: {y: 70, opacity: 0}}} className="about__span1">do</motion.h1>
                            <motion.h1 ref={featuredRef22} animate={animation22} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.1}}, hidden: {y: 70, opacity: 0}}} className="about__span1">great</motion.h1>
                            <motion.h1 ref={featuredRef22} animate={animation22} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.2}}, hidden: {y: 70, opacity: 0}}} className="about__span1">things.</motion.h1>
                            <motion.h1 ref={featuredRef22} animate={animation22} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.3}}, hidden: {y: 70, opacity: 0}}} className="about__span1">But</motion.h1>
                            </h1>
                        </div>
                        <div className="about__div20">
                            <h1 className="about__line2">
                            <motion.h1 ref={featuredRef23} animate={animation23} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.4}}, hidden: {y: 70, opacity: 0}}} className="about__span1">we</motion.h1>
                            <motion.h1 ref={featuredRef24} animate={animation24} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.5}}, hidden: {y: 70, opacity: 0}}} className="about__span1">managed</motion.h1>
                            <motion.h1 ref={featuredRef24} animate={animation24} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.6}}, hidden: {y: 70, opacity: 0}}} className="about__span1">to</motion.h1>
                            <motion.h1 ref={featuredRef24} animate={animation24} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.7}}, hidden: {y: 70, opacity: 0}}} className="about__span1">do</motion.h1>
                            <motion.h1 ref={featuredRef24} animate={animation24} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.8}}, hidden: {y: 70, opacity: 0}}} className="about__span1">it.</motion.h1>
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="about__div21">
                    <div className="about__div22">
                        <h1 className="about__line3">
                        <motion.h1 ref={featuredRef25} animate={animation25} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 2.9}}, hidden: {y: 70, opacity: 0}}} className="about__span2">Web</motion.h1>
                        <motion.h1 ref={featuredRef26} animate={animation26} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 3}}, hidden: {y: 70, opacity: 0}}} className="about__span2">Design</motion.h1>
                        </h1>
                        <h1 className="about__line3">
                        <motion.h1 ref={featuredRef27} animate={animation27} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 3.1}}, hidden: {y: 70, opacity: 0}}} className="about__span2">UI</motion.h1>
                        <motion.h1 ref={featuredRef28} animate={animation28} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 3.2}}, hidden: {y: 70, opacity: 0}}} className="about__span2">Design</motion.h1></h1>
                        <h1 className="about__line3">
                        <motion.h1 ref={featuredRef29} animate={animation29} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 3.3}}, hidden: {y: 70, opacity: 0}}} className="about__span2">User</motion.h1>
                        <motion.h1 ref={featuredRef30} animate={animation30} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 3.4}}, hidden: {y: 70, opacity: 0}}} className="about__span2">Experience</motion.h1>
                        </h1>
                        <h1 className="about__line3">
                        <motion.h1 ref={featuredRef31} animate={animation31} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 3.5}}, hidden: {y: 70, opacity: 0}}} className="about__span2">Branding</motion.h1>
                        </h1>
                        <h1 className="about__line3">
                        <motion.h1 ref={featuredRef32} animate={animation32} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 3.6}}, hidden: {y: 70, opacity: 0}}} className="about__span2">Digital</motion.h1>
                        <motion.h1 ref={featuredRef33} animate={animation33} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 3.7}}, hidden: {y: 70, opacity: 0}}} className="about__span2">Strategy</motion.h1>
                        </h1>
                        <h1 className="about__line3"><motion.h1 ref={featuredRef34} animate={animation34} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 3.8}}, hidden: {y: 70, opacity: 0}}} className="about__span2">Development</motion.h1>
                        </h1>
                    </div>
                    <div className="about__div23">
                        <h2 className="about__line3">
                        <motion.h2 ref={featuredRef35} animate={animation35} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 3.8}}, hidden: {y: 70, opacity: 0}}} className="about__span2">Animation</motion.h2>
                        </h2>
                        <h2 className="about__line3">
                        <motion.h2 ref={featuredRef36} animate={animation36} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 3.9}}, hidden: {y: 70, opacity: 0}}} className="about__span2">HTML/</motion.h2>
                        <motion.h1 ref={featuredRef37} animate={animation37} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 4}}, hidden: {y: 70, opacity: 0}}} className="about__span2">CSS/</motion.h1>
                        <motion.h1 ref={featuredRef37} animate={animation37} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 4.1}}, hidden: {y: 70, opacity: 0}}} className="about__span2">JS</motion.h1>
                        </h2>
                        <h2 className="about__line3">
                        <motion.h2 ref={featuredRef38} animate={animation38} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 4.2}}, hidden: {y: 70, opacity: 0}}} className="about__span2">Backend/</motion.h2>
                        <motion.h1 ref={featuredRef39} animate={animation39} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 4.3}}, hidden: {y: 70, opacity: 0}}} className="about__span2">API</motion.h1>
                        <motion.h1 ref={featuredRef39} animate={animation39} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 4.4}}, hidden: {y: 70, opacity: 0}}} className="about__span2">integration</motion.h1>
                        </h2>
                        <h2 className="about__line3">
                        <motion.h2 ref={featuredRef40} animate={animation40} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 4.5}}, hidden: {y: 70, opacity: 0}}} className="about__span2">WordPress</motion.h2>
                        </h2>
                        <h2 className="about__line3">
                        <motion.h2 ref={featuredRef41} animate={animation41} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 4.6}}, hidden: {y: 70, opacity: 0}}} className="about__span2">Frontend</motion.h2>
                        </h2>
                        <h2 className="about__line3">
                        <motion.h2 ref={featuredRef42} animate={animation42} initial = 'hidden' variants = {{visible: {y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 4.7}}, hidden: {y: 70, opacity: 0}}} className="about__span2">React</motion.h2>
                        </h2>
                    </div>
                </div>
            </div>
            <div className="about__div24"><h3>Love it!! Take a Experience</h3></div>
        </div>
    )
}

export default AboutUs;
